import * as React from 'react';
import { Redirect } from 'react-router';
import { RedirectProps } from 'react-router-dom';

import { WindowLocationService } from '../../../commonInfra/services/WindowLocationService';

// Wrapper component that appends URLSearchParams as a string to Redirect's 'to' prop
export function RedirectWithURLSearchParamsWrapper(props: RedirectProps) {
  const {
    to,
    ...rest
  } = props;
  return <Redirect to={`${to}${WindowLocationService.getHashQueryString()}`} {...rest} />;
}
